import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeActivitiesRejectedByProfessionals = (): IColumn[] => {
  const { getLegends } = useLegends();
  return [
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 270,
    },
    {
      title: 'Data',
      dataKey: 'date',
    },
    {
      title: 'Tarefa',
      dataKey: 'task',
      width: 240,
    },

    {
      title: getLegends('LOCAL_ESTAGIO', false),
      dataKey: 'place',
      width: 160,
    },
    {
      title: 'Situação',
      dataKey: 'situation',
    },
    {
      title: 'Rejeitada em',
      dataKey: 'validatedAt',
    },
  ];
};
